import { z } from "zod/v4";
import { nuqsCommaArray } from "#/modules/util.pagination/search.nuqs";

// Search params schema for lesadministratie statistieken: class filter and date range.

/** URL state for lesadministratie statistieken. Empty `klasIds` means all classes. */
export const lessonAdministrationSearchSchema = z.object({
  klasIds: nuqsCommaArray,
  from: z.string().optional(),
  to: z.string().optional(),
});

export type LesadministratieStatistiekenFilters = z.infer<typeof lessonAdministrationSearchSchema>;

/** Defaults stripped from the URL by `stripSearchParams`. */
export const LESSON_ADMINISTRATION_SEARCH_DEFAULTS: Pick<
  LesadministratieStatistiekenFilters,
  "klasIds"
> = {
  klasIds: [],
};
